import React from 'react';
import { CardMedia, Stack } from '@mui/material';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useDevice } from '../hooks/useResponsive';

CarHistorySection.propTypes = {};
export default function CarHistorySection() {
  const { isMobile } = useDevice();

  return (
    <Stack id="Whatsapp">
      {/* <CardMedia component="img" src="/assets/images/HomeMobile/carHistory.png" alt="Car History" /> */}
      {isMobile ? (
        <a href="https://wa.me/918891940560" target="_blank" rel="noopener noreferrer">
          <CardMedia component="img" src="/assets/images/HomeMobile/carHistory.webp" alt="Car History" />
        </a>
      ) : (
        // <Stack sx={{ maxWidth: '100%', px: '75px', pb: '2rem', pt: '4rem' }}>
        //   <Stack gap={4} direction="row">
        //     <Stack width="45%" justifyContent="center">
        //       <Typography
        //         variant="subtitle1"
        //         sx={{
        //           fontWeight: 600,
        //           fontSize: '38px',
        //           zIndex: 2,
        //           background: 'linear-gradient(to right, #EA5D16, #F6851F)',
        //           WebkitBackgroundClip: 'text',
        //           WebkitTextFillColor: 'transparent',
        //           display: 'inline-block',
        //           lineHeight: 1.2,
        //         }}
        //       >
        //         Get Car History <br />
        //         through <br />
        //         Whatsapp{' '}
        //       </Typography>{' '}
        //       <a href="https://wa.me/918891940560" target="_blank" rel="noopener noreferrer">
        //         <CardMedia
        //           component="img"
        //           src="/assets/images/HomeMobile/Whatsapp.png"
        //           alt="Car History"
        //           sx={{ maxWidth: '269px', mt: 5 }}
        //         />
        //       </a>
        //     </Stack>{' '}
        //     <Stack width="55%">
        //       <CardMedia component="img" src="/assets/images/HomeMobile/carHistoryWeb.webp" alt="Car History" />
        //     </Stack>
        //   </Stack>
        // </Stack>
        <Stack sx={{ maxWidth: '100%', px: '75px', pb: '2rem', pt: '4rem' }}>
          <a href="https://wa.me/918891940560" target="_blank" rel="noopener noreferrer">
            <CardMedia component="img" src="/assets/images/HomeMobile/wh.webp" alt="Car History" />
          </a>
        </Stack>
      )}
    </Stack>
  );
}
